// extracted by mini-css-extract-plugin
export var centerText = "_eh-8";
export var container = "_eh-0";
export var doughnutContainer = "_eh-7";
export var legend = "_eh-a";
export var legendItemColorDisplay = "_eh-b";
export var legendItemLabel = "_eh-d";
export var legendItemValue = "_eh-c";
export var lg = "_eh-5";
export var maxWidth = "_eh-9";
export var md = "_eh-4";
export var responsive = "_eh-6";
export var sm = "_eh-3";
export var xs = "_eh-2";
export var xxs = "_eh-1";